var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticStyle:{"height":"100%","width":"100%","position":"absolute"},attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":64,"indeterminate":"","color":"primary"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }